import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    textSearch: '',
    isTextInputFocused: false
}

const textSearchSlice = createSlice({
    name: 'textSearch',
    initialState,
    reducers: {
        setTextSearch: (state, action: PayloadAction<string>) => {
            state.textSearch = action.payload;
        },
        setIsTextInputFocused: (state, action: PayloadAction<boolean>) => {
            state.isTextInputFocused = action.payload;
        },
    }
});

export const { setTextSearch, setIsTextInputFocused } = textSearchSlice.actions;
export default textSearchSlice.reducer; 